import { HttpClient } from '@angular/common/http';
import { NewCustomerNote } from './customer-note.types';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomerNoteService {
	private notesUrl = (customerId: number) => `api/customers/${customerId}/notes`;
	private noteUrl = (customerId: number, noteId: number) => `api/customers/${customerId}/notes/${noteId}`;

	constructor(private http: HttpClient) { }

	addNote(customerId: number, newNote: NewCustomerNote): Promise<number> {
		return this.http.post<number>(this.notesUrl(customerId), newNote).toPromise();
	}

	deleteNote(customerId: number, noteId: number): Promise<void> {
		return this.http.delete<void>(this.noteUrl(customerId, noteId)).toPromise();
	}
}
